import { useRouter } from 'next/router';
import Script from 'next/script';
import { useEffect } from 'react';
import styles from './PaddleCheckout.module.css';

export default function PaddleCheckout(props) {
   const { user, selectedPlan } = props;

   const router = useRouter();

   const { coupon } = router.query;

   function paddleOpen() {
      let Paddle = window.Paddle;
      Paddle.Checkout.open({
         method: 'inline',
         product: selectedPlan.paddleId,
         email: user.email,
         coupon: coupon,
         frameTarget: styles.paddleCheckout,
         frameInitialHeight: 500,
         frameStyle: 'width: 100%; height: 500px; border: 0;',
      });
   }

   // update paddle when plan changed
   useEffect(() => {
      if (!window.Paddle) return;
      paddleOpen();
   }, [selectedPlan]);

   return (
      <>
         <div className={styles.paddleCheckout} />
         <Script
            src="https://cdn.paddle.com/paddle/paddle.js"
            onLoad={() => {
               let Paddle = window.Paddle;
               // Check if env is development set paddle environment to sandbox
               if (process.env.NODE_ENV === 'development') {
                  Paddle.Environment.set('sandbox');
               }
               Paddle.Setup({
                  vendor: Number(process.env.NEXT_PUBLIC_PADDLE_VENDOR_ID),
                  eventCallback: function (data) {
                     const checkoutContainer = document.querySelector(`.${styles.paddleCheckout}`);
                     const checkoutIframe = checkoutContainer.querySelector('iframe');
                     checkoutIframe.style.height = '';
                     // send state change notification
                     props.onChange(data);
                  },
               });
               paddleOpen();
            }}
         />
      </>
   );
}
